import { AdminPanelName, HistoryStackEntry } from '../../../state';
import { AsyncAdminCreatePanel } from '../admin-create-panel';
import { AdminEventListPanel } from '../admin-event-list-panel';
import { AdminEventPanel } from '../admin-event-panel';
import { AsyncAdminHomePanel } from '../admin-home-panel';
import { AsyncAdminPageListPanel } from '../admin-page-list-panel';
import { AsyncAdminPagePanel } from '../admin-page-panel';
import { AdminPlaceListPanel } from '../admin-place-list-panel';
import { AdminPlacePanel } from '../admin-place-panel';
import { AdminSiteSettingsPanel } from '../admin-site-settings-panel';
import { AdminWaitingPanel } from '../admin-waiting-panel';
import React from 'react';

export const getPanel = (
  entry: HistoryStackEntry<AdminPanelName> | null,
): React.ReactElement => {
  if (!entry) {
    return <AsyncAdminHomePanel />;
  }

  switch (entry.name) {
    case AdminPanelName.Create:
      return <AsyncAdminCreatePanel />;
    case AdminPanelName.Event:
      return <AdminEventPanel {...entry.state} />;
    case AdminPanelName.EventList:
      return <AdminEventListPanel />;
    case AdminPanelName.PageList:
      return <AsyncAdminPageListPanel />;
    case AdminPanelName.Page:
      return <AsyncAdminPagePanel {...entry.state} />;
    case AdminPanelName.PlaceList:
      return <AdminPlaceListPanel />;
    case AdminPanelName.Place:
      return <AdminPlacePanel {...entry.state} />;
    case AdminPanelName.Waiting:
      return <AdminWaitingPanel />;
    case AdminPanelName.SiteSettings:
      return <AdminSiteSettingsPanel />;
    case AdminPanelName.Home:
    default: {
      return <AsyncAdminHomePanel />;
    }
  }
};
